<template>
  <div class="keitai-type edit-item" v-if="editingData && options">
    <div class="head"><b>形態種別</b></div>
    <div class="data">
      <input-radio :options="options.keitai_type" v-model="editingData.keitai_type"
        :error="getError(editingData, 'keitai_type')" :disabled="disabled"></input-radio>
      <p class="current-data" v-if="currentData?.keitai_type">{{ getOptionsLabel(options.keitai_type, currentData.keitai_type) }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { useKoyouKeiyakuInit } from '@/composable/koyoukeiyaku/init';
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();
    const { getOptionsLabel } = useKoyouKeiyakuInit()

    return {
      getOptionsLabel,
      getError
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
